// react
import { useMemo } from 'react';
import styled, { css } from 'styled-components';

// components
import { Icon } from '@/components/atoms/Icon/Icon';

// theme
import { theme } from '@/theme';
import { Label } from '@/components/atoms';

export interface ShortlistItem {
  id: string;
  title: string;
  subTitle: string;
  isComplete: boolean;
  order: number;
}

interface ShortlistProgressProps {
  className?: string;
  shortlistItems?: ShortlistItem[];
}

export const ShortlistProgress = ({
  shortlistItems,
}: ShortlistProgressProps) => {
  // memos
  const sortedshortlistItems = useMemo(() => {
    const shortlistItemsCopy = shortlistItems?.slice();
    return shortlistItemsCopy?.sort((a, b) => a.order - b.order);
  }, [shortlistItems]);

  return (
    <Wrapper>
      <Connector />
      {sortedshortlistItems?.map((item: ShortlistItem) => (
        <ActionRow key={item.id}>
          <IconWrapper>
            <StyledIcon
              icon={'check'}
              fontSize={16}
              fill={
                item.isComplete
                  ? theme.color.success[40]
                  : theme.color.neutral[30]
              }
              $color={!item.isComplete ? theme.color.neutral[10] : undefined}
            />
          </IconWrapper>
          <Containier>
            <StyledLabel id={item.title} text={item.title} />
          </Containier>
        </ActionRow>
      ))}
    </Wrapper>
  );
};

interface StyledIconProps {
  $color?: string;
}
const StyledIcon = styled(Icon)<StyledIconProps>`
  ${(props) =>
    props.$color &&
    css`
      color: ${props.$color};
    `}
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Connector = styled.div`
  height: 78%;
  width: 3rem;
  position: absolute;
  top: 11%;
  left: 16px;
  border-left: 2px dashed ${theme.color.neutral[50]};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: ${theme.spacing[8]};
`;

const Containier = styled.div`
  width: 100%;
  display: flex;
  padding: ${(props) => props.theme.spacing[16]} 0;
  align-content: center;
`;

const ActionRow = styled.div`
  gap: ${(props) => props.theme.spacing[12]};
  display: flex;
`;

const StyledLabel = styled(Label)`
  font: ${(props) => props.theme.typography.body.md.medium};
  color: ${(props) => props.theme.color.neutral[90]};
`;

ShortlistProgress.displayName = 'ShortlistProgress';

export default ShortlistProgress;
